module.exports = __webpack_public_path__ + "img/unit6.a790f52e.jpg";